import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ProjectBriefDownload = () => {
  const handleDownload = () => {
    // Simulate download action
    alert('Project Brief Template download started. In production, this would trigger a PDF download.');
  };

  const briefSections = [
    {
      icon: 'Target',
      title: 'Project Goals',
      description: 'Define your business objectives and success metrics'
    },
    {
      icon: 'Users',
      title: 'Target Audience',
      description: 'Identify your users and their needs'
    },
    {
      icon: 'Layout',
      title: 'Features & Scope',
      description: 'List required functionality and integrations'
    },
    {
      icon: 'Palette',
      title: 'Design Preferences',
      description: 'Share visual inspiration and brand guidelines'
    },
    {
      icon: 'Calendar',
      title: 'Timeline & Budget',
      description: 'Outline your constraints and expectations'
    },
    {
      icon: 'FileText',
      title: 'Technical Requirements',
      description: 'Specify platforms, integrations, and constraints'
    }
  ];

  return (
    <div className="p-6 md:p-8 lg:p-10 rounded-lg bg-card border border-border">
      <div className="mb-6 md:mb-8">
        <div className="flex items-start gap-4 mb-4">
          <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary/10 flex-shrink-0">
            <Icon name="Download" size={28} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-bold font-heading text-foreground mb-2">
              Project Brief Template
            </h2>
            <p className="text-sm md:text-base text-muted-foreground">
              Download our comprehensive project brief template to organize your thoughts before our consultation. This helps ensure we cover all important aspects of your project.
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 md:mb-8">
        {briefSections?.map((section, index) => (
          <div
            key={index}
            className="flex items-start gap-3 p-4 rounded-lg bg-muted/50 border border-border"
          >
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 flex-shrink-0">
              <Icon name={section?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm md:text-base font-bold font-heading text-foreground mb-1">
                {section?.title}
              </h3>
              <p className="text-xs md:text-sm text-muted-foreground">
                {section?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="space-y-4">
        <Button
          variant="default"
          size="lg"
          onClick={handleDownload}
          iconName="Download"
          iconPosition="left"
          fullWidth
        >
          Download Project Brief Template (PDF)
        </Button>

        <div className="p-4 rounded-lg bg-muted/50 border border-border">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
            <div className="text-xs md:text-sm text-muted-foreground">
              <p className="font-medium text-foreground mb-1">Why use this template?</p>
              <ul className="space-y-1 list-disc list-inside">
                <li>Ensures you don't miss critical project details</li>
                <li>Helps me provide more accurate time and cost estimates</li>
                <li>Speeds up the initial consultation process</li>
                <li>Serves as a reference document throughout development</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="p-4 rounded-lg bg-primary/10 border border-primary/20">
          <div className="flex items-start gap-3">
            <Icon name="Lightbulb" size={20} className="text-primary flex-shrink-0 mt-0.5" />
            <div className="text-xs md:text-sm text-muted-foreground">
              <p className="font-medium text-foreground mb-1">Pro Tip</p>
              <p>Complete the brief before our consultation call. This allows us to dive deeper into technical solutions rather than spending time on basic requirements gathering.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectBriefDownload;